module.exports = __webpack_public_path__ + "static/media/porque-full2.cb251700.jpg";